import { Link } from 'react-router-dom'
import logoMark from '../assets/logo-mark.png'

export function Logo({ className = '' }: { className?: string }) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 font-extrabold tracking-tight ${className}`}>
      <img src={logoMark} alt="HorseSheli" className="h-9 w-9 object-contain" />
      <span className="text-xl">
        Horse<span className="text-brand-600 dark:text-brand-300">Sheli</span>
      </span>
    </Link>
  )
}
